var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{attrs:{"type":"flex","justify":"center","align":"center"}},[_c('el-col',{attrs:{"span":6}},[_c('h1',[_vm._v("Home")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }